import { z } from "zod";
import { getDefaultPeriodFilterString } from "@/utils";
import { optionalFilterString } from "@/schemas/filter.schema";

export const bookingFilterBaseSchema = z.object({
	search: optionalFilterString,
	period: optionalFilterString,
	needsCorrection: z.boolean().optional(),
	doNotInvoice: z.boolean().optional(),
	statuses: optionalFilterString,
	invoiced: z.boolean().optional(),
	licensePlate: optionalFilterString,
	vehicleName: optionalFilterString,
	includeCanceled: z.boolean().default(true),
	status: optionalFilterString,
});

export const bookingFilterSchema = bookingFilterBaseSchema.transform((data) => {
	// Always apply default period if no period is defined
	if (!data.period) {
		return { ...data, period: getDefaultPeriodFilterString() };
	}

	return data;
});
